import useUserInfoQuery from './useUserInfoQuery'

export default useUserInfoQuery

export { default as getCacheKey } from './getCacheKey'
